import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/timto-logo.svg'
import _imports_1 from './assets/logo_sf_gheorghe.svg'
import _imports_2 from './assets/logo_covasna.png'
import _imports_3 from './assets/logo_harghita.jpg'
import _imports_4 from './assets/odocs_logo_mic_ro.png'


const _withScopeId = n => (_pushScopeId("data-v-c7352366"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  class: "title__current__page col-6",
  style: {"text-align":"left","margin-top":"2px"}
}
const _hoisted_3 = {
  key: 0,
  class: "title__current__page col-6",
  style: {"text-align":"right","height":"35px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"height":"35px"}
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  style: {"width":"250px","height":"200px","background-color":"#EEF3FA"}
}
const _hoisted_7 = {
  class: "q-pa-xs",
  style: {"min-width":"300px","max-width":"400px","max-height":"600px","background-color":"#EEF3FA"}
}
const _hoisted_8 = { class: "fast__search__label--medium" }
const _hoisted_9 = {
  class: "fast__search__label--medium",
  style: {"white-space":"nowrap"}
}
const _hoisted_10 = { class: "fast__search__label--thin" }
const _hoisted_11 = {
  key: 0,
  class: "element"
}
const _hoisted_12 = {
  class: "fast__search__label--reference",
  style: {"white-space":"wrap"}
}
const _hoisted_13 = { class: "row no-wrap q-pa-md" }
const _hoisted_14 = { class: "column" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mb-md flex flex-center" }, "Setari utilizator", -1))
const _hoisted_16 = { style: {"display":"flex"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Nr.randuri tabele: ", -1))
const _hoisted_18 = { class: "text__input--bold" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "column items-center" }
const _hoisted_21 = { class: "q-mt-md q-mb-xs" }
const _hoisted_22 = { class: "text__important" }
const _hoisted_23 = {
  class: "text-subtitle2",
  style: {"white-space":"pre-wrap","word-wrap":"break-word","max-width":"400px"}
}
const _hoisted_24 = {
  class: "text-subtitle2",
  style: {"white-space":"pre-wrap","word-wrap":"break-word","max-width":"400px"}
}
const _hoisted_25 = { class: "text-subtitle2" }
const _hoisted_26 = {
  key: 0,
  class: "text-subtitle2",
  style: {"white-space":"pre-wrap","word-wrap":"break-word","max-width":"400px"}
}
const _hoisted_27 = { style: {"display":"flex"} }
const _hoisted_28 = {
  key: 1,
  style: {"text-align":"right","margin-right":"0.1em"}
}
const _hoisted_29 = {
  key: 0,
  style: {"color":"lightgreen","font-family":"Nunito Sans","font-size":"0.9rem","font-weight":"bold"}
}
const _hoisted_30 = {
  key: 1,
  style: {"color":"red","font-family":"Nunito Sans","font-size":"0.9rem","font-weight":"bold"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "250",
  height: "80"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "200",
  height: "50"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  width: "250",
  height: "60"
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Document", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Document", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare decont", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare deplasare", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare cerere", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare referat", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare pontaj prezenta", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare pontaj proiect", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare cerere concediu", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare solicitari cetateni", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare proiect", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare proiect task", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Administare cereri de concediu", -1))
const _hoisted_48 = { class: "cursor-pointer" }
const _hoisted_49 = { class: "cursor-pointer" }
const _hoisted_50 = { class: "cursor-pointer" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare certificat de urbanism", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare servicii de transport", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Companie", -1))
const _hoisted_54 = { style: {"text-align":"center"} }
const _hoisted_55 = {
  key: 1,
  id: "iframe_preview_scan",
  type: "application/pdf",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none"}
}
const _hoisted_56 = {
  key: 2,
  id: "iframe_preview_scan",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none","display":"block"}
}
const _hoisted_57 = { class: "q-pa-md" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "LICENȚA DE UTILIZARE PLATFORMA ODOCS")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, " ")
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Cod Licență:")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, " ")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "5915648210220231")
  ])
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Denumire: ODOCS - Sistem de management al dezvoltarii aplicatiei Brandteam")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Issue date: 21022023")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, "Users: Unlimited")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, " ")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "5915648210220231_29")
  ])
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Denumire: ODOCS - BI")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Issue date: 13062023")
], -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, "Users: Unlimited")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, " ")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "5915648210220231_1615"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Denumire: ODOCS - Pachet Office")
  ])
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Issue date: 13072023")
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, "Users: 10")
], -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, " ")
], -1))
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }
const _hoisted_78 = { class: "absolute-bottom-right q-pa-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_virtual_scroll = _resolveComponent("q-virtual-scroll")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_MenuApp = _resolveComponent("MenuApp")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_WorkOnDocument = _resolveComponent("WorkOnDocument")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_EditDecontDetail = _resolveComponent("EditDecontDetail")!
  const _component_EditDeplasareDetail = _resolveComponent("EditDeplasareDetail")!
  const _component_EditCerereDetail = _resolveComponent("EditCerereDetail")!
  const _component_EditReferatDetail = _resolveComponent("EditReferatDetail")!
  const _component_EditPontajPrezentaDetail = _resolveComponent("EditPontajPrezentaDetail")!
  const _component_EditPontajProiectDetail = _resolveComponent("EditPontajProiectDetail")!
  const _component_EditTimeRequestDetail = _resolveComponent("EditTimeRequestDetail")!
  const _component_EditDocumentCetateniDetail = _resolveComponent("EditDocumentCetateniDetail")!
  const _component_EditProiectDetail = _resolveComponent("EditProiectDetail")!
  const _component_EditProiectTaskDetail = _resolveComponent("EditProiectTaskDetail")!
  const _component_AdminEmployeeTimeRequest = _resolveComponent("AdminEmployeeTimeRequest")!
  const _component_WorkOnAsset = _resolveComponent("WorkOnAsset")!
  const _component_WorkOnPartener = _resolveComponent("WorkOnPartener")!
  const _component_WorkOnFactura = _resolveComponent("WorkOnFactura")!
  const _component_EditCertificateUrbanismDetail = _resolveComponent("EditCertificateUrbanismDetail")!
  const _component_EditServiciiDeTransportDetail = _resolveComponent("EditServiciiDeTransportDetail")!
  const _component_DialogEditGrantCompanyDefault = _resolveComponent("DialogEditGrantCompanyDefault")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpR fFf" }, {
    default: _withCtx(() => [
      (_ctx.sessionIsValid)
        ? (_openBlock(), _createBlock(_component_q_header, {
            key: 0,
            elevated: "",
            style: _normalizeStyle(!['APP_BRANDTEAM'].includes(_ctx.APP_NAME) ? 'background-color: #EEF3FA;color:black;' :  'background-color: #8055A5;')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    dense: "",
                    flat: "",
                    round: "",
                    icon: "menu",
                    onClick: _ctx.onClickOpenMenuLeftOrRedirectLink
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_q_toolbar_title, null, {
                    default: _withCtx(() => [
                      (_ctx.$q.platform.is.desktop)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.currentPageTitle), 1),
                            (['APP_BRANDTEAM'].includes(_ctx.APP_NAME))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.user.auth_for_search=='y' && !(['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) && _ctx.$q.platform.is.desktop)
                    ? (_openBlock(), _createBlock(_component_q_input, {
                        key: 0,
                        dense: "",
                        outlined: "",
                        modelValue: _ctx.inputFastSearch,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputFastSearch) = $event)),
                          _cache[3] || (_cache[3] = (val)=>_ctx.getOptionsDocumentsFastSearch(val))
                        ],
                        ref: "refInputFastSearch",
                        debounce: "500"
                      }, {
                        append: _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearInputFastSearch && _ctx.clearInputFastSearch(...args)))
                          }, [
                            (_ctx.inputFastSearch === '')
                              ? (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 0,
                                  name: "search"
                                }))
                              : (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 1,
                                  name: "clear",
                                  class: "cursor-pointer"
                                }))
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            modelValue: _ctx.refOptionsFastSearch,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refOptionsFastSearch) = $event)),
                            onShow: _ctx.putFocusBackToFastSearch,
                            persistent: "",
                            "no-parent-event": "",
                            "no-refocus": "",
                            "no-focus": ""
                          }, {
                            default: _withCtx(() => [
                              (_ctx.loadingData)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(_component_q_spinner_gears, {
                                      color: "primary",
                                      size: "3em",
                                      class: "absolute-center"
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_virtual_scroll, {
                                    key: 1,
                                    items: _ctx.optionsFastSearch,
                                    dense: ""
                                  }, {
                                    default: _withCtx(({ item, index }) => [
                                      _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_q_list, {
                                          bordered: "",
                                          separator: "",
                                          style: {"border":"1px solid #dddddd","border-radius":"5px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                              clickable: "",
                                              key: index,
                                              style: {"margin":"2px","padding":"2px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, {
                                                  onClick: ($event: any) => (_ctx.getDocumentFromFastSearch(item))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.id_doc) + " / " + _toDisplayString(item.data_doc), 1),
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.tip_request) + " / " + _toDisplayString(item.den_registru), 1),
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.nume_denumire), 1),
                                                    (item.ref_nr_doc != null)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                          _createElementVNode("span", _hoisted_12, _toDisplayString(item.ref_nr_doc) + " / " + _toDisplayString(item.ref_data_doc) + " / " + _toDisplayString(item.ref_den_registru), 1)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)), [
                                              [_directive_ripple]
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["items"]))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onShow"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    "icon-right": "person",
                    color: ['APP_BRANDTEAM'].includes(_ctx.APP_NAME) ? 'white' : 'primary',
                    class: _normalizeClass(['APP_BRANDTEAM'].includes(_ctx.APP_NAME) ? 'text-white' : 'text-blue'),
                    label: _ctx.user.last_name + ' ' + _ctx.user.first_name,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClickOpenOrCloseMenuRight(true)))
                  }, {
                    default: _withCtx(() => [
                      (!(['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                        ? (_openBlock(), _createBlock(_component_q_menu, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _hoisted_17,
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.nrRanduriTabel), 1)
                                    ]),
                                    _createVNode(_component_q_popup_edit, {
                                      modelValue: _ctx.nrRanduriTabel,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nrRanduriTabel) = $event)),
                                      validate: val => (val || val > 0) && (1*val >= 1 && 1*val <= 100)
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_q_input, {
                                          autofocus: "",
                                          dense: "",
                                          modelValue: scope.value,
                                          "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                          style: {"min-width":"300px"},
                                          value: _ctx.nrRanduriTabel,
                                          hint: "Nr.randuri tabele",
                                          rules: [
                            (val) => ((val && val > 0) || scope.validate(scope.value) || 'Completati numar de randul!'),                              
                            (val) => ((1*val >= 1 && 1*val <= 100) || scope.validate(scope.value) || 'Numarul de rand maxim acceptabil este 100!')
                          ]
                                        }, {
                                          after: _withCtx(() => [
                                            _createVNode(_component_q_btn, {
                                              flat: "",
                                              dense: "",
                                              color: "negative",
                                              icon: "cancel",
                                              onClick: _withModifiers(scope.cancel, ["stop"])
                                            }, null, 8, ["onClick"]),
                                            _createVNode(_component_q_btn, {
                                              flat: "",
                                              dense: "",
                                              color: "positive",
                                              icon: "check_circle",
                                              onClick: _withModifiers(($event: any) => (_ctx.setNrRanduriTabel(scope)), ["stop"]),
                                              disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                            }, null, 8, ["onClick", "disable"])
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "validate"])
                                  ]),
                                  (_ctx.processEnvMode === 'development')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createVNode(_component_q_select, {
                                          outlined: "",
                                          modelValue: _ctx.currentLocale,
                                          "onUpdate:modelValue": [
                                            _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentLocale) = $event)),
                                            _ctx.switchLanguage
                                          ],
                                          options: _ctx.supportedLocales,
                                          "option-label": _ctx.translatedLanguage,
                                          label: _ctx.t(`locale.label`),
                                          "emit-value": "",
                                          "map-options": "",
                                          "lazy-rules": "",
                                          style: {"max-height":"7vh","margin-top":"10px"},
                                          dense: "",
                                          "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                          rules: [val => val && val.length > 0 || 'Alegeti limba!'],
                                          readonly: ""
                                        }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "option-label", "label", "rules"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (['APP_MEAT', 'APP_MULTICOMPANY'].includes(_ctx.APP_NAME))
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        color: "primary",
                                        label: "Schimbare companie",
                                        style: {"margin-top":"10px","display":"flex","align-items":"center"},
                                        onClick: _ctx.openChangeCompany
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isADUserLogged && _ctx.user.is_address_gmail == false)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 2,
                                        color: "primary",
                                        label: "Schimbare parola",
                                        style: {"margin-top":"10px","display":"flex","align-items":"center"},
                                        onClick: _ctx.openChangePassword
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isADUserLogged)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 3,
                                        color: "primary",
                                        label: "Log out",
                                        style: _normalizeStyle((_ctx.user.is_address_gmail == true) ? 'margin-top:10px;display: flex; align-items: center;' : 'margin-top:5px;display: flex; align-items: center;'),
                                        onClick: _ctx.logOut
                                      }, null, 8, ["style", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_q_separator, {
                                  vertical: "",
                                  inset: "",
                                  class: "q-mx-lg"
                                }),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.user.last_name) + " " + _toDisplayString(_ctx.user.first_name), 1),
                                    _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.user.org_unit_id?.organization_unit_descriere), 1),
                                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.user.job_id?.job_title), 1),
                                    _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.user.email_address), 1),
                                    (['APP_MEAT', 'APP_MULTICOMPANY'].includes(_ctx.APP_NAME))
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.company.denumire), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["color", "class", "label"]),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    icon: "notifications",
                    color: ['APP_BRANDTEAM'].includes(_ctx.APP_NAME) ? 'white' : 'primary',
                    class: _normalizeClass(['APP_BRANDTEAM'].includes(_ctx.APP_NAME) ? 'text-white' : 'text-blue')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToViewWithParamString('Dashboard', 'documente_repartizate')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_badge, {
                              color: "blue",
                              transparent: "",
                              style: {"position":"relative","top":"-5px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrOfMyDocuments)) + " ", 1),
                                _createVNode(_component_q_tooltip, {
                                  "transition-show": "rotate",
                                  "transition-hide": "rotate"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Documente repartizate ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_btn, {
                          flat: "",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToViewWithParamString('Dashboard', 'aprobari_avizari')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_badge, {
                              color: "red",
                              transparent: "",
                              style: {"position":"relative","top":"-5px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrOfTask)) + " ", 1),
                                _createVNode(_component_q_tooltip, {
                                  "transition-show": "rotate",
                                  "transition-hide": "rotate"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Actiuni solicitate ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["color", "class"]),
                  (['APP_CV', 'APP_CJCV', 'APP_HR'].includes(_ctx.APP_NAME))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_ctx.APP_NAME_TITLE === 'MEDIU LIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.APP_NAME_TITLE), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.APP_NAME_TITLE), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      (!(['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) && _ctx.user.userid != 0)
        ? (_openBlock(), _createBlock(_component_q_drawer, {
            key: 1,
            modelValue: _ctx.leftMenuOpen,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.leftMenuOpen) = $event)),
            side: "left",
            behavior: "mobile",
            overlay: "",
            elevated: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item, {
                    clickable: "",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.aboutPopupOpen = true && ['APP_MAGIC'].includes(_ctx.APP_NAME)))
                  }, {
                    default: _withCtx(() => [
                      (['APP_CV'].includes(_ctx.APP_NAME))
                        ? (_openBlock(), _createBlock(_component_q_item_section, {
                            key: 0,
                            avatar: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          }))
                        : (['APP_CJCV'].includes(_ctx.APP_NAME))
                          ? (_openBlock(), _createBlock(_component_q_item_section, {
                              key: 1,
                              avatar: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32
                              ]),
                              _: 1
                            }))
                          : (['APP_HR'].includes(_ctx.APP_NAME))
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                avatar: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_33
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 3,
                                avatar: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_34
                                ]),
                                _: 1
                              }))
                    ]),
                    _: 1
                  }),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.leftMenuOpen = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "close"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Inchide")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple],
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_MenuApp, {
                userid: _ctx.user.userid
              }, null, 8, ["userid"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      ((['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) && _ctx.user.userid != 0)
        ? (_openBlock(), _createBlock(_component_q_drawer, {
            key: 2,
            modelValue: _ctx.rightMenuOpen,
            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.rightMenuOpen) = $event)),
            side: "right",
            behavior: "mobile",
            overlay: "",
            elevated: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, null, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onClickOpenOrCloseMenuRight(false)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "black",
                            name: "close"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Inchide")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple],
                    [_directive_close_popup]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToViewWithParamString('Dashboard', 'documente_repartizate')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "black",
                            name: "dashboard"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Dashboard")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiunipersonal=='y'))
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 0,
                        "expand-separator": "",
                        label: "Planning",
                        icon: "warning_amber"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToViewWithParam('PontajPrezenta', 0)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Pontajul meu")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToViewWithParam('MyTimesRequests', 0)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Concediile mele")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goToView('AlocariEntitatiAcces')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Planificare meeting")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToView('AlocariEntitatiAcces')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Rezervare sala")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_asset=='y'))
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 1,
                        "expand-separator": "",
                        label: "Notificari",
                        icon: "notifications_none"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.goToViewWithParam('AssetsNotificationsList', 1)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Rapoarte pagube")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goToView('Pontaje')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Acces cladire")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'Flota')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Monitorizare flote")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'IOT')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Echipamente IOT")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_asset=='y'))
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 2,
                        "expand-separator": "",
                        label: "Care",
                        icon: "favorite_outlined"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'Medicina muncii')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Medicina muncii")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'Telemedicina')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Telemedicina")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiunihr=='y'))
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 3,
                        "expand-separator": "",
                        label: "Operatiuni HR",
                        icon: "work_outline"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.goToViewWithParam('PontajPrezenta', 1)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Pontaje")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          (_ctx.user.is_admin=='y' || _ctx.user.auth_for_monitoringholiday=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 0,
                                clickable: "",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.goToViewWithParam('AdminPrezenta', 1)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Monitorizare concedii")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y' || _ctx.user.auth_for_rightdaysholiday=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                clickable: "",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.goToView('DrepturiCO')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Drepturi Concedii")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y' || _ctx.user.auth_for_officialdaysoff=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 2,
                                clickable: "",
                                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.goToView('NomZiLibereOficial')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Administrare zile libere")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.goToView('ReportsHR')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Rapoarte")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'Medicina muncii')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Medicina muncii")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniacces=='y'))
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 4,
                        "expand-separator": "",
                        label: "Operatiuni acces",
                        icon: "qr_code_scanner"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniacces=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 0,
                                clickable: "",
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.goToView('Monitorizare')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Monitorizare acces")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniacces=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                clickable: "",
                                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.goToView('AlocariEntitatiAcces')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Alocari acces")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_asset=='y'))
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 5,
                        "expand-separator": "",
                        label: "Monitorizare",
                        icon: "date_range"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'Flota')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Flote")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.goToViewWithParam('NomDeplasari', 0)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Deplasari")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'IOT')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("IOT")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'Telemedicina')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Telemedicina")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.goToViewWithParamString('Assets', 'Medicina muncii')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Medicina muncii")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.goToView('AlocariEntitatiAcces')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { avatar: "" }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Sali de sedinte si birouri")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 6,
                        "expand-separator": "",
                        label: "Nomenclatoare",
                        icon: "manage_accounts"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 0,
                                clickable: "",
                                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.goToView('NomCateg')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Categorii documente")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                clickable: "",
                                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.goToView('NomTipDoc')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Tipuri documente")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 2,
                                clickable: "",
                                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.goToView('NomRegistre')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Registre")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 3,
                                clickable: "",
                                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.goToView('NomCategActive')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Categorii active")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 4,
                                clickable: "",
                                onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.goToView('NomTipActive')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Tipuri active")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 5,
                                clickable: "",
                                onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.goToView('NomJobs')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Functii")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_proiect=='y'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 6,
                                clickable: "",
                                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.goToView('Proiecte')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Proiecte")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 7,
                                clickable: "",
                                onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.goToView('NomEntitateAcces')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Entitati acces")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 8,
                                clickable: "",
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goToView('Adrese')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Adrese")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 9,
                                clickable: "",
                                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.goToView('NomJudet')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Judete")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 10,
                                clickable: "",
                                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.goToView('NomLocalitate')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Localitati")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 7,
                        "expand-separator": "",
                        label: "Administrare",
                        icon: "security"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 0,
                                clickable: "",
                                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.goToView('NomUsers')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Utilizatori")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                clickable: "",
                                onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.goToView('NomFlux')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Fluxuri")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 2,
                                clickable: "",
                                onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.goToView('NomOrgUnit')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Org Units")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 3,
                                clickable: "",
                                onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.goToView('ParamsTypeFiles')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Parametri atasamente")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.user.is_admin=='y')
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 4,
                                clickable: "",
                                onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.goToView('LogAdmin')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Audit log")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isADUserLogged && _ctx.user.is_address_gmail == false && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 8,
                        clickable: "",
                        onClick: _ctx.openChangePassword
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "black",
                                name: "password"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Schimbare Parola")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _ctx.logOut
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "black",
                            name: "logout"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("LOG OUT")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_ripple]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openDocumentDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 3,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_35,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowDocument
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WorkOnDocument, {
                        appid: _ctx.appidDocToWorkOnIt,
                        withFinalizeButton: _ctx.withFinalizeButton,
                        withRepartizareButton: _ctx.withRepartizareButton,
                        accesFrom: _ctx.accesFrom,
                        closeWindow: _ctx.closeWindowDocument,
                        task: _ctx.task
                      }, null, 8, ["appid", "withFinalizeButton", "withRepartizareButton", "accesFrom", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openDocumentDialogReference')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 4,
            modelValue: _ctx.dialogOpenReference,
            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.dialogOpenReference) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_36,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowDocumentReference
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WorkOnDocument, {
                        appid: _ctx.appidDocToWorkOnItReference,
                        withFinalizeButton: _ctx.withFinalizeButtonReference,
                        withRepartizareButton: _ctx.withRepartizareButtonReference,
                        accesFrom: _ctx.accesFromReference,
                        closeWindow: _ctx.closeWindowDocumentReference,
                        task: _ctx.taskReference
                      }, null, 8, ["appid", "withFinalizeButton", "withRepartizareButton", "accesFrom", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openDecontDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 5,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_37,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowDecont
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditDecontDetail, {
                        appid: _ctx.appidDecontToWorkOnIt,
                        closeWindow: _ctx.closeWindowDecont,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openDeplasareDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 6,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_38,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowDeplasare
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditDeplasareDetail, {
                        appid: _ctx.appidDeplasareToWorkOnIt,
                        closeWindow: _ctx.closeWindowDeplasare,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openCerereDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 7,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_39,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowCerere
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditCerereDetail, {
                        appid: _ctx.appidCerereToWorkOnIt,
                        closeWindow: _ctx.closeWindowCerere,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openReferatDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 8,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_40,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowReferat
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditReferatDetail, {
                        appid: _ctx.appidReferatToWorkOnIt,
                        closeWindow: _ctx.closeWindowReferat,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openPontajPrezentaDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 9,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_41,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowPontajPrezenta
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditPontajPrezentaDetail, {
                        appid: _ctx.appidPontajPrezentaWorkOnIt,
                        closeWindow: _ctx.closeWindowPontajPrezenta,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openPontajProiectDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 10,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_42,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowPontajProiect
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditPontajProiectDetail, {
                        appid: _ctx.appidPontajProiectToWorkOnIt,
                        closeWindow: _ctx.closeWindowPontajProiect,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openTimeRequestDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 11,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_43,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowTimeRequest
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditTimeRequestDetail, {
                        appid: _ctx.appidTimeRequestWorkOnIt,
                        closeWindow: _ctx.closeWindowTimeRequest,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openDocumentCetateniDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 12,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_44,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowDocumentCetateni
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditDocumentCetateniDetail, {
                        appid: _ctx.appidDocumentCetateniToWorkOnIt,
                        closeWindow: _ctx.closeWindowDocumentCetateni,
                        withFinalizeButton: _ctx.withFinalizeButton
                      }, null, 8, ["appid", "closeWindow", "withFinalizeButton"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openProiectDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 13,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_45,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowProiect
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditProiectDetail, {
                        appid: _ctx.appidProiectToWorkOnIt,
                        closeWindow: _ctx.closeWindowProiect
                      }, null, 8, ["appid", "closeWindow"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openProiectTaskDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 14,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_46,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowProiectTask
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditProiectTaskDetail, {
                        appid: _ctx.appidProiectTaskToWorkOnIt,
                        is_all: _ctx.is_all,
                        closeWindow: _ctx.closeWindowProiectTask
                      }, null, 8, ["appid", "is_all", "closeWindow"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openPersonTimeRequest')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 15,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_47,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowPersonTimeRequest
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AdminEmployeeTimeRequest, {
                        marca: _ctx.marcaTimeRequestsWorkOnIt,
                        year: _ctx.yearTimeRequestsWorkOnIt,
                        closeWindow: _ctx.closeWindowPersonTimeRequest
                      }, null, 8, ["marca", "year", "closeWindow"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openAsset')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 16,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, _toDisplayString((['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) ? _ctx.currentPageTitle : 'Asset'), 1),
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowAsset
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WorkOnAsset, {
                        appid: _ctx.appidAssetToWorkOnIt,
                        closeWindow: _ctx.closeWindowAsset
                      }, null, 8, ["appid", "closeWindow"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openPartener')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 17,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, _toDisplayString((['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) ? _ctx.currentPageTitle : 'Partener'), 1),
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowAsset
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"85vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WorkOnPartener, {
                        appid: _ctx.appidPartenerToWorkOnIt,
                        closeWindow: _ctx.closeWindowPartener
                      }, null, 8, ["appid", "closeWindow"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openFactura')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 18,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_50, _toDisplayString((['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) ? _ctx.currentPageTitle : 'Factura'), 1),
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowFactura
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"85vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WorkOnFactura, {
                        appid: _ctx.appidFacturaToWorkOnIt,
                        closeWindow: _ctx.closeWindowAsset
                      }, null, 8, ["appid", "closeWindow"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openCertificateUrbanismDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 19,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_51,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowCertificateUrbanism
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditCertificateUrbanismDetail, {
                        appid: _ctx.appidCertificateUrbanismWorkOnIt,
                        closeWindow: _ctx.closeWindowCertificateUrbanism,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.actionName === 'openServiciiTransportDialog')
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 20,
            modelValue: _ctx.dialogOpen,
            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.dialogOpen) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"95vw","max-width":"95vw","min-height":"95vh","max-height":"95vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                    default: _withCtx(() => [
                      _hoisted_52,
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close",
                        onClick: _ctx.closeWindowServiciiTransport
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, {
                    style: {"min-height":"85vh","max-height":"90vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditServiciiDeTransportDetail, {
                        appid: _ctx.appidServiciiTransportWorkOnIt,
                        closeWindow: _ctx.closeWindowServiciiTransport,
                        task: _ctx.task
                      }, null, 8, ["appid", "closeWindow", "task"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.visibleDialogEditGrantCompanyDefault,
        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.visibleDialogEditGrantCompanyDefault) = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"90vw"} }, {
            default: _withCtx(() => [
              _createVNode(_component_q_bar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, { name: "add_box" }),
                  _hoisted_53,
                  _createVNode(_component_q_space),
                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    dense: "",
                    flat: "",
                    icon: "close",
                    onClick: _ctx.closeWindowCompany
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Close")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogEditGrantCompanyDefault, { fonsave: _ctx.updateStoreCompanyDefault }, null, 8, ["fonsave"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          (_ctx.mesajSeLoadingNomenclatoare != '')
            ? (_openBlock(), _createBlock(_component_q_banner, {
                key: 0,
                "inline-actions": "",
                class: "text-white bg-red"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.mesajSeLoadingNomenclatoare), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showPreviewFile,
        "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.showPreviewFile) = $event)),
        persistent: "",
        maximized: true,
        "transition-show": "slide-up",
        "transition-hide": "slide-down"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_bar, null, {
                default: _withCtx(() => [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.titleForPreviewForm), 1),
                  _createVNode(_component_q_space),
                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    dense: "",
                    flat: "",
                    icon: "close"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, {
                        "transition-show": "rotate",
                        "transition-hide": "rotate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Close")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  (_ctx.downloadingFile)
                    ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                        key: 0,
                        query: "",
                        "track-color": "orange",
                        color: "purple",
                        class: "q-mt-sm"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isPDFFileType)
                    ? (_openBlock(), _createElementBlock("iframe", _hoisted_55))
                    : (_openBlock(), _createElementBlock("img", _hoisted_56))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.aboutPopupOpen,
        "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.aboutPopupOpen) = $event)),
        persistent: "",
        "transition-show": "slide-down",
        "transition-hide": "slide-up"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"90vw","min-height":"30vw","max-height":"30vw"} }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _hoisted_59,
                    _hoisted_60,
                    _hoisted_61,
                    _hoisted_62,
                    _hoisted_63,
                    _hoisted_64,
                    _hoisted_65,
                    _hoisted_66,
                    _hoisted_67,
                    _hoisted_68,
                    _hoisted_69,
                    _hoisted_70,
                    _hoisted_71,
                    _hoisted_72,
                    _hoisted_73,
                    _hoisted_74,
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("p", _hoisted_77, "Versiune platforma Odocs: V" + _toDisplayString(_ctx.APP_INFORMATION.version), 1)
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _withDirectives(_createVNode(_component_q_btn, {
                        label: "Inchide",
                        dense: "",
                        flat: "",
                        icon: "close",
                        size: "sm",
                        color: "primary"
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}